import { Component } from 'react';
import $ from 'jquery';

export default
class LoadingAnimation extends Component {
  render() {

    let isIE9 = $('html').hasClass('ie9');

    return (
      <div className="loading">
        {
          isIE9
            ?
              <div className="loading-text">読込中...</div>
            :
              <div className="sk-fading-circle">
                <div className="sk-circle1 sk-circle"></div>
                <div className="sk-circle2 sk-circle"></div>
                <div className="sk-circle3 sk-circle"></div>
                <div className="sk-circle4 sk-circle"></div>
                <div className="sk-circle5 sk-circle"></div>
                <div className="sk-circle6 sk-circle"></div>
                <div className="sk-circle7 sk-circle"></div>
                <div className="sk-circle8 sk-circle"></div>
                <div className="sk-circle9 sk-circle"></div>
                <div className="sk-circle10 sk-circle"></div>
                <div className="sk-circle11 sk-circle"></div>
                <div className="sk-circle12 sk-circle"></div>
              </div>
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/modules/LoadingAnimation.js
 **/